import React, { ReactNode } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

export interface FormItemProps {
  label?: ReactNode;
  /** @default false */
  error?: string;
  children?: ReactNode;
  className?: string;
}

const label_style = {
  error: css`
    color: ${vars.color.stateNegativePrimary};
  `,
  active: css`
    color: ${vars.color.textSecondary};
  `,
};

export function FormItem({ label, error, children, className }: FormItemProps) {
  return (
    <Container className={className}>
      {label && (
        <Label css={error ? label_style.error : label_style.active} className={Typography.BODY_13_SEMIBOLD}>
          {error ? error : label}
        </Label>
      )}
      {children}
    </Container>
  );
}

const Container = styled.div`
  margin: 8px 0;
`;

const Label = styled.label`
  display: inline-block;
  margin: 0 0 4px 8px;
`;
